import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Container,
  MenuItem,
  TextField,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Backdrop
} from '@mui/material';
import baseURL from '../../config';
import { useParams } from 'react-router-dom';
import { CreditCard } from '@mui/icons-material';

const SubscriptionForm = () => {
  const [email, setEmail] = useState('');
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [vesselCount, setVesselCount] = useState(10);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [vesselOwner, setVesselOwner] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchVesselOwnerDetails = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${baseURL}/api/vesselDetails/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data.data;
        setVesselOwner(data);
        if (data?.email) {
          setEmail(data.email); // Auto-fill email
        }
      } catch (err) {
        setMessage('Failed to fetch vessel owner details.');
        console.error('Error fetching vessel owner details:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchVesselOwnerDetails();
  }, [id]);

  const handleSubmit = async (paymentMethod = "stripe") => {
    setLoading(true);
    setMessage('');

    try {
      const vesselOwnerId = localStorage.getItem('urlID');

      if (!vesselOwnerId) {
        setMessage('Vessel Owner ID not found in local storage.');
        setLoading(false);
        return;
      }

      const payload = {
        email,
        vesselCount: Number(vesselCount),
        billingCycle,
        vesselOwnerId,
        paymentMethod,
      };

      const subRes = await axios.post(`${baseURL}/api/vesselowner-subscription`, payload);

      const { status } = subRes.data;
      if (status) {
        setMessage(`Subscription created successfully! Status: ${status}`);
        setTimeout(() => window.location.reload(), 1000); // reload after 1 second
      } else {
        setMessage('Subscription created, but no status returned.');
      }
    } catch (error) {
      console.error(error);
      setMessage(error.response?.data?.message || 'Something went wrong.');
    }

    setLoading(false);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={6} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
          Subscribe to a Plan
        </Typography>

        <Box component="form" noValidate>
          <TextField
            fullWidth
            type="email"
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled
          />
          <TextField
  fullWidth
  required
  type="number"
  label="Number of Vessels per Month"
  variant="outlined"
  margin="normal"
  inputProps={{ min: 1, step: 1 }}
  value={vesselCount}
  onChange={(e) => setVesselCount(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === '-' || e.key === 'e') {
      e.preventDefault();
    }
  }}
/>

          <TextField
            select
            fullWidth
            label="Billing Cycle"
            value={billingCycle}
            onChange={(e) => setBillingCycle(e.target.value)}
            margin="normal"
          >
            <MenuItem value="monthly">Monthly</MenuItem>
            <MenuItem value="yearly">Yearly</MenuItem>
          </TextField>

          <Button
            fullWidth
            variant="contained"
            startIcon={<CreditCard />}
            sx={{
              mt: 3,
              backgroundColor: "red",
              color: "#fff",
              fontWeight: 600,
            }}
            onClick={() => handleSubmit("stripe")}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Subscribe'}
          </Button>

          {message && (
            <Alert severity="info" sx={{ mt: 3 }}>
              {message}
            </Alert>
          )}
        </Box>
      </Paper>

      {/* Fullscreen Loading Backdrop */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};

export default SubscriptionForm;
